<script lang="ts">
    import { Col,Row } from "sveltestrap";
    import Card from "../UiCommenCard.svelte";
    import {Horizontalalignment,Oneoftwocolumns, VerticalalignmentMessage} from "../../../utils/Constant/Constant";
    import data from "../../../Data/ComponentData/Ui-kits/Grid/Grid.json"
</script>
<Col sm="12">
    <Card cardHeaderprops="pb-0" headerTitle={Horizontalalignment} CardBodyprops="grid-showcase grid-align">
      <div slot="contentbody">
        <p>{VerticalalignmentMessage}</p>
        <Row class="justify-content-start">
          <Col xs="4">
            <span>{Oneoftwocolumns}</span>
          </Col>
          <Col xs="4">
            <span>{Oneoftwocolumns}</span>
          </Col>
        </Row>
        {#each data.Horizontalalignmentdata as gridItem }
            <Row class="  justify-content-{gridItem.class}">
                <Col xs="4">
                  <span>{Oneoftwocolumns}</span>
                </Col>
                <Col xs="4">
                  <span>{Oneoftwocolumns}</span>
                </Col>
            </Row>
        {/each}
      </div>
    </Card>
</Col>